module.exports = __webpack_public_path__ + "edcb6d4921bc5bc8.svg";